import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const CameraFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M19.29 7h-2l-1.1-1.67c-.42-.63-1.15-1-1.9-1H9.71c-.75 0-1.48.38-1.9 1L6.71 7h-2C3.44 7 2.42 8.02 2.42 9.29v8.08c0 1.27 1.02 2.29 2.29 2.29h14.58c1.27 0 2.29-1.02 2.29-2.29V9.29c0-1.27-1.02-2.29-2.29-2.29ZM12 17.79a5.17 5.17 0 0 1-5.17-5.17c0-2.86 2.31-5.15 5.17-5.15s5.17 2.31 5.17 5.17-2.31 5.15-5.17 5.15Zm7-7.56h-.92a.675.675 0 0 1-.65-.71c.02-.35.29-.63.65-.65h.83c.38-.02.69.27.71.65.02.38-.25.69-.63.71H19Z" />
      <Path d="M12.17 9.71c-1.62 0-2.95 1.33-2.95 2.95s1.33 2.93 2.95 2.93 2.95-1.33 2.95-2.95-1.33-2.93-2.95-2.93Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default CameraFilled
